module.exports = __webpack_public_path__ + "img/new_gzh_main.1169e4c5.png";